import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { Check, X } from 'lucide-react';
export function WhoFor() {
  return <SectionWrapper className="bg-brand-dark" data-id="element-226">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-227">
        <div className="grid md:grid-cols-2 gap-8" data-id="element-228">
          {/* Who it is for */}
          <div className="bg-brand-card border border-brand-green/30 rounded-2xl p-8 md:p-10" data-id="element-229">
            <h3 className="text-2xl font-display uppercase text-white mb-8 flex items-center gap-3" data-id="element-230">
              <span className="bg-brand-green text-brand-dark p-1 rounded" data-id="element-231">
                <Check className="w-6 h-6" data-id="element-232" />
              </span>
              ESTO ES PARA:
            </h3>
            <ul className="space-y-6" data-id="element-233">
              {['Hombres que han sido rechazados para una hipoteca o préstamo de auto.', 'Inmigrantes que están construyendo su patrimonio y necesitan un puntaje de 700+.', 'Personas con colecciones, pagos tarde o deudas médicas que quieren limpiar su nombre.'].map((item, i) => <li key={i} className="flex items-start gap-4 text-gray-300" data-id="element-234">
                  <Check className="w-6 h-6 text-brand-green shrink-0 mt-0.5" data-id="element-235" />
                  <span className="leading-relaxed" data-id="element-236">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Who it is NOT for */}
          <div className="bg-brand-card border border-red-500/30 rounded-2xl p-8 md:p-10 opacity-80" data-id="element-237">
            <h3 className="text-2xl font-display uppercase text-white mb-8 flex items-center gap-3" data-id="element-238">
              <span className="bg-red-500 text-white p-1 rounded" data-id="element-239">
                <X className="w-6 h-6" data-id="element-240" />
              </span>
              ESTO NO ES PARA:
            </h3>
            <ul className="space-y-6" data-id="element-241">
              {['Gente que busca evadir deudas legítimas y recientes sin intención de mejorar sus finanzas.', 'Personas que no están dispuestas a ir al correo y enviar una carta certificada.'].map((item, i) => <li key={i} className="flex items-start gap-4 text-gray-400" data-id="element-242">
                  <X className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-243" />
                  <span className="leading-relaxed" data-id="element-244">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </SectionWrapper>;
}